import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export const DeleteInvoiceCancel = createAction('[Customer data: Delete Invoice]: Delete Invoice Cancel');

export const DeleteInvoice = createAction('[Customer data: Delete Invoice]: Delete Invoice');

export const DeleteInvoiceSuccess = createAction(
  '[Customer data: Delete Invoice]: Delete Invoice Success',
  props<{ res: string }>(),
);

export const DeleteInvoiceFailed = createAction(
  '[Customer data: Delete Invoice]: Delete Invoice Failed',
  props<{ error: HttpErrorResponse }>(),
);
